import React, { Component } from 'react';
import "./sidenav.css"
import  AuthService  from "../api/authentication.js";
import {
    Link,
  } from 'react-router-dom'
  const Auth = new AuthService();
class SideNav extends Component {
    logout=(event)=>{
        event.preventDefault();
        Auth.logout()
       this.props.logout()
    }
    
    
   

  render() {

    

    const notallowed ={
      "cursor": "not-allowed"
    }
    // console.log("dash =======-", this.props.isActive)

  //  console.log("dash disable=======-", this.props.disableLink)
    return (
            <div className="SideNav"> 
            
               <div className="sidenav">
               <br/>
               <div className="image-tag">
               
               <div>
                     {
                          this.props.organizers404 ?
                          <div>
                             {
                                this.props.vanImage? 
                                  <p></p>
                                // <div>
                                // {
                                //       this.props.vanImage === "" ? ( 
                                //         <i className="fas fa-image info-setting-logo-font"></i>
                                //       )
                                //       :

                                //       (
                                //       <img src={this.props.vanImage}  width="100" className="image-circular"/>
                                //       )
                                //   }  
                                // </div>
                                  :
                                  <div> 
                                            {/* <i className="fas fa-image info-setting-logo-font"></i> */}
                                  </div>
                              }
                          </div>
                          :
                          <div>
                           
                           <i className="fas fa-sitemap info-setting-logo-font"></i>
                           <br/>
                            <small className="info-setting-logo-add-logo">Create  Organizers</small>
                          </div>
                     }        
               </div>
                
                   
                     
                     
               
               
               </div>
               <div className="sidenav-name">
               <br/>
                <h6 className="title is-6 name-title"><b> {this.props.name} </b>  </h6>
                <span className="subtitle is-7 font-email">{this.props.email}</span>
               
               </div> 
               <br/>
               {/* <hr className="line-side-nav"/>   */}
            
                <div className="sidenav-tilte">
                <div>
                  {
                    this.props.disableLink  === undefined ? 
                       <div>
                        
                            <Link to="/dashboard" className={this.props.isActiveD ? 'active-link-true' : "sidelist-sub-link"}> <i className="fas fa-tachometer-alt icon-link"></i> Dashboard</Link>
                            <Link to="/activity" className={this.props.isActive ? 'active-link-true' : "sidelist-sub-link"}> <i className="far fa-money-bill-alt icon-link"></i> Activity</Link>
                            {
                              this.props. organizers404 ?
                              
                              <Link to="/event/new" className={this.props.isActiveE ? 'active-link-true' : "sidelist-sub-link"}><i className=" fab fa-wpforms icon-link"></i>Create Event</Link>
                                :
                                <p>

                                </p> 
                            }
                            {
                              this.props. organizers404 ? 
                              <Link to="/events" className={this.props.isActiveF ? 'active-link-true' : "sidelist-sub-link"}>   <i className="fas fa-clipboard-list icon-link"></i>My Event</Link>
                                :
                                <p>
                                  <Link to="/info" className="sidelist-sub-link"><i className="fas fa-sitemap icon-link"></i>Create Organizer</Link>
                                </p>
                            }
                           {
                              this.props. organizers404 ?
                                <Link to="/update-info" className={this.props.isActiveM ? 'active-link-true' : "sidelist-sub-link"}><i className="fas fa-sitemap icon-link"></i>Organizer's Profile</Link>
                                :
                                <p></p>
                            }
                            
                          
                        
                            <Link to="/setting" className={this.props.isActiveS ? 'active-link-true' : "sidelist-sub-link"}><i className="fas fa-user-cog icon-link"></i>Settings</Link>
                            <button className="button is-success" onClick={this.logout}><i className="fas fa-sign-out-alt"></i>Logout</button>
                          </div>
                       
                       :
                      <div>
                           <div>
                              <a style={{ cursor: 'not-allowed'}}  className="side-nave-over"  > <i className="fas fa-tachometer-alt icon-link" ></i> Dashboard</a>
                              <a style={{ cursor: 'not-allowed'}}   className="sidelist-sub-link"> <i className="fa-solid fa-school icon-link"></i> Activity</a>
                              <a  style={{ cursor: 'not-allowed'}}  className="sidelist-sub-link"><i className=" fab fa-wpforms  icon-link"></i>Builder</a>
                                {
                                  this.props. organizers404 ?
                                    <Link to="/update-info" className="sidelist-sub-link"><i className="fas fa-sitemap icon-link"></i>	Organizer</Link>
                                    :
                                    <p></p>
                                }
                              <a style={{ cursor: 'not-allowed'}}   className="sidelist-sub-link"><i className="fas fa-user-cog icon-link"></i>Settings</a>
                              <button className="button is-success" onClick={this.logout}><i className="fas fa-sign-out-alt"></i>Logout</button>
                            </div> 
                      </div>

                  }
                </div> 


              </div>   
            </div>

          </div>     

    )

}





}

export default SideNav;


// WEBPACK FOOTER //
// ./src/component/sidenav/sidenav.js